import { AxiosResponse } from 'axios';
import AppConstants from '../constants/AppConstants';
import { AxiosPayRatesClient } from '../proxy/ProxyClients';
import { PayRateJobsiteAddOnResPage, PayRateJobsiteAddOnRes, CreatePayRateJobsiteAddOnReq, PayRateJobsiteAddOnReq, PayRateShiftTimeAddOnResPage, PayRateShiftTimeAddOnRes, CreatePayRateShiftTimeAddOnReq, PayRateShiftTimeAddOnReq, PayRateShiftDurationAddOnResPage, PayRateShiftDurationAddOnRes, CreatePayRateShiftDurationAddOnReq, PayRateShiftDurationAddOnReq } from '../proxy/proxy';

// const api = new AccountApi(new Configuration({ basePath: AppConstants.BASE_API_URL }));
// const api = new Client(AppConstants.BASE_API_URL, configureAxios());

const PreCheckQuestionsService = {
  getAllJobSiteAddOns: () => AxiosPayRatesClient.pagePayRateJobsiteAddOns({
    pageNumber: 1,
    pageSize: AppConstants.MAX_PAGE_SIZE
  }).then((resp: PayRateJobsiteAddOnResPage) => {
    const result: Array<PayRateJobsiteAddOnRes> = resp?.items || [];
    return result.filter((question: any) => !question.isSoftDeleted);
  }),
  getJobSiteAddOnById: (id: number): Promise<PayRateJobsiteAddOnRes> => AxiosPayRatesClient.getPayRateJobsiteAddOn(id).then((resp) => resp),
  createJobSiteAddOn: (data: CreatePayRateJobsiteAddOnReq): Promise<PayRateJobsiteAddOnRes> =>
    AxiosPayRatesClient.createPayRateJobsiteAddOns(data)
      .then((resp) => {
        const item = resp?.items?.[0];
        if (item !== undefined) return item;
        throw new Error('Response is undefined');
      }),
  updateJobSiteAddOn: (id: number, data: PayRateJobsiteAddOnReq): Promise<PayRateJobsiteAddOnRes> => AxiosPayRatesClient.updatePayRateJobsiteAddOn(id, data).then((resp) => resp),
  assignUsersToJobSiteAddOn: (payRateJobsiteAddOnId: number, userIds: Array<number>): Promise<PayRateJobsiteAddOnRes> => AxiosPayRatesClient.assignUsersToPayRateJobsiteAddOn({
    userIds,
    payRateJobsiteAddOnId
  }).then((resp) => resp),
  unassignUsersToJobSiteAddOn: (payRateJobsiteAddOnId: number, userIds: Array<number>): Promise<PayRateJobsiteAddOnRes> => AxiosPayRatesClient.unassignUsersFromPayRateJobsiteAddOn({
    userIds,
    payRateJobsiteAddOnId
  }).then((resp) => resp),
  deleteJobSiteAddOn: (id: number): Promise<void> => AxiosPayRatesClient.deletePayRateJobsiteAddOns([id]),

  getAllShiftTimeAddOns: () => AxiosPayRatesClient.pagePayRateShiftTimeAddOns({
    pageNumber: 1,
    pageSize: AppConstants.MAX_PAGE_SIZE
  }).then((resp: PayRateShiftTimeAddOnResPage) => {
    const result: Array<PayRateShiftTimeAddOnRes> = resp?.items || [];
    return result.filter((question: any) => !question.isSoftDeleted);
  }),
  getShiftTimeAddOnById: (id: number): Promise<PayRateShiftTimeAddOnRes> => AxiosPayRatesClient.getPayRateShiftTimeAddOn(id).then((resp) => resp),
  createShiftTimeAddOn: (data: CreatePayRateShiftTimeAddOnReq): Promise<PayRateShiftTimeAddOnRes> =>
    AxiosPayRatesClient.createPayRateShiftTimeAddOns(data)
      .then((resp) => {
        const item = resp?.items?.[0];
        if (item !== undefined) return item;
        throw new Error('Response is undefined');
      }),
  updateShiftTimeAddOn: (id: number, data: PayRateShiftTimeAddOnReq): Promise<PayRateShiftTimeAddOnRes> => AxiosPayRatesClient.updatePayRateShiftTimeAddOn(id, data).then((resp) => resp),
  assignUsersToShiftTimeAddOn: (payRateShiftTimeAddOnId: number, userIds: Array<number>): Promise<PayRateShiftTimeAddOnRes> => AxiosPayRatesClient.assignUsersToPayRateShiftTimeAddOn({
    userIds,
    payRateShiftTimeAddOnId
  }).then((resp) => resp),
  unassignUsersToShiftTimeAddOn: (payRateShiftTimeAddOnId: number, userIds: Array<number>): Promise<PayRateShiftTimeAddOnRes> => AxiosPayRatesClient.unassignUsersFromPayRateShiftTimeAddOn({
    userIds,
    payRateShiftTimeAddOnId
  }).then((resp) => resp),
  deleteShiftTimeAddOn: (id: number): Promise<void> => AxiosPayRatesClient.deletePayRateShiftTimeAddOns([id]),

  getAllShiftDurationAddOns: () => AxiosPayRatesClient.pagePayRateShiftDurationAddOns({
    pageNumber: 1,
    pageSize: AppConstants.MAX_PAGE_SIZE
  }).then((resp: PayRateShiftDurationAddOnResPage) => {
    const result: Array<PayRateShiftDurationAddOnRes> = resp?.items || [];
    return result.filter((question: any) => !question.isSoftDeleted);
  }),
  getShiftDurationAddOnById: (id: number): Promise<PayRateShiftDurationAddOnRes> => AxiosPayRatesClient.getPayRateShiftDurationAddOn(id).then((resp) => resp),
  createShiftDurationAddOn: (data: CreatePayRateShiftDurationAddOnReq): Promise<PayRateShiftDurationAddOnRes> =>
    AxiosPayRatesClient.createPayRateShiftDurationAddOns(data)
      .then((resp) => {
        const item = resp?.items?.[0];
        if (item !== undefined) return item;
        throw new Error('Response is undefined');
      }),
  updateShiftDurationAddOn: (id: number, data: PayRateShiftDurationAddOnReq): Promise<PayRateShiftDurationAddOnRes> => AxiosPayRatesClient.updatePayRateShiftDurationAddOn(id, data).then((resp) => resp),
  assignUsersToShiftDurationAddOn: (payRateShiftDurationAddOnId: number, userIds: Array<number>): Promise<PayRateShiftDurationAddOnRes> => AxiosPayRatesClient.assignUsersToPayRateShiftDurationAddOn({
    userIds,
    payRateShiftDurationAddOnId
  }).then((resp) => resp),
  unassignUsersToShiftDurationAddOn: (payRateShiftDurationAddOnId: number, userIds: Array<number>): Promise<PayRateShiftDurationAddOnRes> => AxiosPayRatesClient.unassignUsersFromPayRateShiftDurationAddOn({
    userIds,
    payRateShiftDurationAddOnId
  }).then((resp) => resp),
  deleteShiftDurationAddOn: (id: number): Promise<void> => AxiosPayRatesClient.deletePayRateShiftDurationAddOns([id]),
};

export default PreCheckQuestionsService;
